var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"outline":"","color":_vm.fechaHoraPasadoHorario}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.fechaHoraFormateada))])])
}
var staticRenderFns = []

export { render, staticRenderFns }